var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAuthGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0572 18.6874V15.6819H27.1852C27.2842 16.2057 27.3353 16.8253 27.3353 17.4961C27.3353 19.751 26.7189 22.5393 24.7323 24.526C22.7999 26.5382 20.331 27.6113 17.0603 27.6113C10.9982 27.6113 5.90063 22.6735 5.90063 16.6113C5.90063 10.5492 10.9982 5.61133 17.0603 5.61133C20.414 5.61133 22.8031 6.92724 24.5981 8.6424L22.4773 10.7632C21.1901 9.55587 19.4462 8.61684 17.0572 8.61684C12.6303 8.61684 9.16806 12.1845 9.16806 16.6113C9.16806 21.0382 12.6303 24.6058 17.0572 24.6058C19.9285 24.6058 21.5638 23.4528 22.6115 22.4052C23.4611 21.5556 24.02 20.3419 24.2404 18.6842L17.0572 18.6874Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAuthGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/auth-google.2a6ab8561a60d7c8b252e08a8362f3ef.svg";